import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOOdontologyTissuePatient } from "../../models/odo/BOOdontologyTissuePatient.model";

@Injectable({
  providedIn: 'root'
}

)
export class OdontologyTissuePatientService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OdontologyTissuePatient';

    constructor(private http:HttpClient){}
// #region First

    getAll():Observable<BOOdontologyTissuePatient[]>{
        return this.http.get<BOOdontologyTissuePatient[]>(this.myAppUrl + this.myApiUrl);
    }


    saveOrupdateOdontologyTissuePatient(backgrounds:BOOdontologyTissuePatient[]):Observable<BOOdontologyTissuePatient[]>
    {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(backgrounds);
        return this.http.post<BOOdontologyTissuePatient[]>(this.myAppUrl + this.myApiUrl + '/saveOrUpdateOdontologyTissuePatient',body,httpOptions);
      //          return this.http.post<BOOdontologyPatientBackground[]>(this.myAppUrl + this.myApiUrl + '/saveOrUpdateOdontologyTissuePatient',body,httpOptions);

    }


    getOdontologyHistoriesByClinicId(clinicHistoryId:number):Observable<BOOdontologyTissuePatient[]>{
        return this.http.get<BOOdontologyTissuePatient[]>(this.myAppUrl + this.myApiUrl + '/getOdontologyHistoriesByClinicId/' + clinicHistoryId);
    }
// #endregion First

//#region Single

    getAllByPatientId(patientId:number):Observable<BOOdontologyTissuePatient[]>{
        return this.http.get<BOOdontologyTissuePatient[]>(this.myAppUrl + this.myApiUrl+'/getAllByPatientId/'+patientId);
    }
  createOrUpdateOdontologyTissuePatientSingle(patientId:number, disease:BOOdontologyTissuePatient):Observable<BOOdontologyTissuePatient>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOOdontologyTissuePatient>(this.myAppUrl + this.myApiUrl + '/createOrUpdateOdontologyTissuePatientSingle/' + patientId,body,httpOptions);
  }

  deleteOdontologyTissuePatientSingle(id:number):Observable<BOOdontologyTissuePatient>
  {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOOdontologyTissuePatient>(this.myAppUrl + this.myApiUrl + '/deleteOdontologyTissuePatientSingle/' + id,null,httpOptions);
  }


//#endregion Single


}
